import { combineReducers } from 'redux';

import customContent from '../../../../CustomContent/src/app/reducers/customContentReducer';
import chatScript from '../../../../ContactChat/src/app/reducers/chatScriptReducer';
import customerServiceInfo from '../../../../YourDedicatedTeams/src/app/reducers/customerServiceInfoReducer';
import crmArticles from '../reducers/crmArticleReducer';

const rootReducer = combineReducers({
    customContent,
    customerServiceInfo,
    crmArticles,
    chatScript
});

export default rootReducer;